import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";

import VCalendar from "v-calendar";
import "vuetify/dist/vuetify.min.css";
import "./styles.css";
import "@mdi/font/css/materialdesignicons.css";

import { initSocialLogin } from "./services/firebase";
import { initDeepLinks } from "./services/deepLinks";

Vue.use(VCalendar, { componentPrefix: "vc" });
Vue.config.productionTip = false;

(async () => {
  try {
    await initSocialLogin();



    console.log("SocialLogin inicializado");
  } catch (e) {
    console.error("Init error:", e);
  }

  initDeepLinks(router);

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
})();
